export default function ContactFormSection() {
  return (
    <section className="py-20 bg-gradient-to-br from-teal-50 via-white to-cyan-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8">
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-teal-500 to-cyan-500 text-white px-6 py-3 rounded-full text-sm font-semibold mb-6 shadow-xl">
              <i className="ri-mail-send-line text-xl"></i>
              <span>Demande de Devis</span>
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-3">Demandez un Devis Gratuit</h2>
            <p className="text-xl text-gray-600">Remplissez le formulaire et nous vous répondrons dans les 24h</p>
          </div>
          
          <form
            id="contact-form"
            data-readdy-form
            action="https://readdy.ai/api/form/d5i03s3gekujqjrtsrig"
            method="POST"
            className="bg-white rounded-2xl p-8 shadow-2xl border-2 border-teal-100"
            onSubmit={(e) => {
              e.preventDefault();
              const form = e.currentTarget;
              const formData = new FormData(form);
              
              // Validation
              const name = formData.get('name') as string;
              const email = formData.get('email') as string;
              const phone = formData.get('phone') as string;
              const message = formData.get('message') as string;
              
              if (!name || !email || !phone || !message) {
                alert('Veuillez remplir tous les champs obligatoires');
                return;
              }
              
              if (message.length > 500) {
                alert('Le message ne peut pas dépasser 500 caractères');
                return;
              }
              
              // Submit
              fetch('https://readdy.ai/api/form/d5i03s3gekujqjrtsrig', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams(formData as any).toString(),
              })
                .then(() => {
                  alert('✅ Votre demande a été envoyée avec succès ! Nous vous contacterons rapidement.');
                  form.reset();
                })
                .catch(() => {
                  alert('❌ Une erreur est survenue. Veuillez réessayer.');
                });
            }}
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                  Nom complet *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  className="w-full px-4 py-3 bg-white border-2 border-gray-300 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                  placeholder="Votre nom"
                />
              </div>
              
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                  Email *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  className="w-full px-4 py-3 bg-white border-2 border-gray-300 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                  placeholder="votre@email.com"
                />
              </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div>
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                  Téléphone *
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  required
                  className="w-full px-4 py-3 bg-white border-2 border-gray-300 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                  placeholder="0800.20.410"
                />
              </div>
              
              <div>
                <label htmlFor="service" className="block text-sm font-medium text-gray-700 mb-2">
                  Type de service
                </label>
                <select
                  id="service"
                  name="service"
                  className="w-full px-4 py-3 bg-white border-2 border-gray-300 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm cursor-pointer"
                >
                  <option value="">Sélectionnez un service</option>
                  <option value="chassis">Réparation de châssis</option>
                  <option value="porte">Porte coulissante</option>
                  <option value="volet-manuel">Volet roulant manuel</option>
                  <option value="volet-motorise">Volet roulant motorisé</option>
                  <option value="vitrage">Double/Triple vitrage</option>
                  <option value="quincaillerie">Quincaillerie</option>
                </select>
              </div>
            </div>
            
            <div className="mb-6">
              <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-2">
                Adresse
              </label>
              <input
                type="text"
                id="address"
                name="address"
                className="w-full px-4 py-3 bg-white border-2 border-gray-300 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                placeholder="Votre adresse complète"
              />
            </div>
            
            <div className="mb-6">
              <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                Message *
              </label>
              <textarea
                id="message"
                name="message"
                required
                maxLength={500}
                rows={4}
                className="w-full px-4 py-3 bg-white border-2 border-gray-300 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm resize-none"
                placeholder="Décrivez votre besoin (max 500 caractères)"
              ></textarea>
              <p className="text-xs text-gray-500 mt-2">Maximum 500 caractères</p>
            </div>
            
            <button
              type="submit"
              className="w-full bg-gradient-to-r from-teal-600 to-teal-700 text-white px-8 py-4 rounded-lg font-semibold hover:from-teal-700 hover:to-teal-800 transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              <i className="ri-send-plane-fill mr-2"></i>
              Envoyer ma demande
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
